export function libraryEntitiesSelector(state) {
  return state.local.library.entities
}
